import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './Authentication/auth.guard';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';

const routes: Routes = [  {
  path: '',
  canActivate: [AuthGuard],
  loadChildren: () => import('./modules/layout/layout.module')
    .then(m => m.LayoutModule)
},
{
  path: 'login',
  loadChildren: () => import('./modules/login/login.module')
    .then(m => m.LoginModule)
},
{
  path: 'home',
  loadChildren: () => import('./modules/home-pages/home.module')
    .then(m => m.HomeModule)
},
{ path: 'PageNotFound', component: PageNotFoundComponent },
{ path: '**', redirectTo: 'PageNotFound' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
